import Link from "next/link";
import { buildExploreTagHref } from "../_lib/explore-detail-hrefs";
import { useExploreRoute } from "../_lib/explore-route-context";
import type { AllTagsItem } from "../types";

interface TagCardProps {
  tag: AllTagsItem;
}

const KIND_STYLES: Record<AllTagsItem["kind"], string> = {
  TOOL: "bg-[var(--explore-kind-tool-bg)] text-[var(--explore-kind-tool-text)]",
  MODEL:
    "bg-[var(--explore-kind-model-bg)] text-[var(--explore-kind-model-text)]",
  TOPIC:
    "bg-[var(--explore-kind-topic-bg)] text-[var(--explore-kind-topic-text)]",
};

export function buildTagCardHref({
  exploreBase,
  tag,
}: {
  exploreBase: string;
  tag: AllTagsItem;
}) {
  return buildExploreTagHref({
    exploreBase,
    tagSlug: tag.slug,
  });
}

export function TagCard({ tag }: TagCardProps) {
  const { exploreBase } = useExploreRoute();

  const isEmpty = tag.storyCount === 0;

  return (
    <Link
      className={`hover:-translate-y-0.5 flex flex-col rounded-xl border border-[var(--explore-border-light)] bg-[var(--explore-bg-card)] p-4 no-underline shadow-[var(--explore-inline-shadow)] transition-all hover:border-[var(--explore-accent-teal)] hover:shadow-[var(--explore-shadow-hover)] ${isEmpty ? "opacity-50" : ""}`}
      href={buildTagCardHref({ exploreBase, tag })}
    >
      <div className="mb-1.5 flex items-center justify-between">
        <span className="font-bold text-[0.95rem] text-[var(--explore-text-primary)]">
          {tag.displayName}
        </span>
        <span className="rounded-full bg-[var(--explore-bg-highlight)] px-2 py-0.5 font-semibold text-[0.75rem] text-[var(--explore-text-muted)]">
          {tag.storyCount}
        </span>
      </div>
      <div className="mt-auto flex items-center gap-2">
        <span
          className={`rounded px-2 py-0.5 font-semibold text-[0.65rem] uppercase ${KIND_STYLES[tag.kind]}`}
        >
          {tag.kind.toLowerCase()}
        </span>
        <span className="text-[0.75rem] text-[var(--explore-text-muted)]">
          {tag.storyCount} {tag.storyCount === 1 ? "story" : "stories"}
        </span>
      </div>
    </Link>
  );
}
